/**
 * Events set out of doors on the pool deck, posted by a beat.
 *
 * A card like any on the board, set like any room, graded like any room, with
 * two differences that are both the place and not a rule. The deck is its own
 * anchor grid (`LEVEL.poolDeck`), and everything for it has to come out of
 * banquet storage, through the building, down the apron stairs and round the
 * service drive, because there is no other way to the pool from back of house.
 * And the pool is open: the guests in it can see the whole deck from the
 * water, and what they see, they say, like guests anywhere.
 *
 *   lead       minutes after the shift starts that it is due
 *   doorsAfter minutes after it is due that the guests arrive
 *   works      zones the job puts you in (`access.js`): the apron, which is
 *              the only way out of the building with a cart on a rope
 *
 * Everything else is a card's own fields, as `data/story.js`'s finale has them.
 */
export const POOLSETS = [
  {
    id: 'pool-set',
    code: 'BEO 1500',
    title: 'Poolside Welcome',
    client: 'Kingsbridge Association',
    owner: 'frontdesk',
    type: 'reception',
    room: 'pool',
    venue: 'pool',
    covers: 48,
    lead: 270,
    doorsAfter: 30,
    setup: {
      tableType: 'round',
      tableCount: 6,
      chairsPerTable: 8,
      linen: 'white',
      layout: { col: 2, row: 1, cols: 3, rows: 2 },
      staging: ['Keep the pool edge clear'],
    },
    award: { banquets: 18, frontdesk: 10 },
    works: ['restricted-apron'],
    note: 'The pool stays open. They will be watching you set it from the water.',
    shortfalls: [],
  },
];

export const POOLSETS_BY_ID = Object.freeze(Object.fromEntries(POOLSETS.map((row) => [row.id, row])));

export default POOLSETS;
